import { getCurrentInstance } from 'vue'
import VueWechatPlugin from 'vue-wechat-plugin'
import { getWechatJsConfig } from '@/api/wechat'

// 创建插件安装函数
const installWechatPlugin = (app) => {
  console.log('安装微信插件...')
  app.use(VueWechatPlugin, {
    // 微信公众号AppID
    appId: process.env.VUE_APP_WECHAT_MP_APP_ID,
    
    // 自定义获取签名的方法
    getSignature: (url, callback) => {
      getWechatJsConfig(url)
        .then(res => {
          if (res && res.code === 0 && res.data) {
            callback(res.data);
          } else {
            console.error('获取微信签名失败:', res);
            callback(null);
          }
        })
        .catch(err => {
          console.error('获取微信签名出错:', err);
          callback(null);
        });
    },
    
    // 需要使用的JS接口列表
    jsApiList: [
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'hideMenuItems',
      'showMenuItems'
    ],
    
    // 是否开启调试模式
    debug: process.env.NODE_ENV === 'development',
    
    // 自动初始化 - 禁用以防止重复调用
    autoInit: false,
    
    // 自动处理URL中的问号问题
    fixUrlProtocol: true
  })
}

/**
 * 配置微信分享
 * @param {Object} shareData 分享数据
 * @returns {Promise}
 */
export const setupWechatShare = (shareData) => {
  return new Promise((resolve, reject) => {
    // 获取当前组件实例
    const instance = getCurrentInstance()
    const wechat = instance?.appContext.config.globalProperties.$wechat || window.$wechat
    
    if (!wechat) {
      console.warn('微信插件未初始化')
      reject(new Error('微信插件未初始化'))
      return
    }
    
    // 确保图片URL是绝对路径
    const ensureAbsoluteUrl = (url) => {
      if (!url) return 'https://mall.sainbainu.com/static/images/sharelogo.png'
      if (url.startsWith('http')) return url
      if (url.startsWith('/')) return `${window.location.origin}${url}`
      return `${window.location.origin}/${url}`
    }
    
    const config = {
      title: shareData.title || document.title,
      desc: shareData.desc || shareData.title || '蒙古丽人商城',
      link: shareData.link || window.location.href,
      imgUrl: ensureAbsoluteUrl(shareData.imgUrl || 'https://mall.sainbainu.com/static/images/sharelogo.png')
    }
    
    console.log('配置微信分享:', config)
    
    wechat.ready(() => {
      // 使用插件提供的share方法，会自动处理新旧版本API
      wechat.share(config).then(() => {
        console.log('微信分享配置成功')
        resolve(true)
      }).catch(err => {
        console.error('微信分享配置失败:', err)
        reject(err)
      })
    })
  })
}

/**
 * 检测是否在微信环境中
 * @returns {Boolean}
 */
export const isWechatBrowser = () => {
  // 获取当前组件实例
  const instance = getCurrentInstance()
  const wechat = instance?.appContext.config.globalProperties.$wechat || window.$wechat
  
  if (wechat && wechat.isWechat) {
    return wechat.isWechat
  }
  
  // 备用检测方法
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('micromessenger')
}

export default {
  install: installWechatPlugin
}